var ctrlopt = ctrlopt,
  FB = FB || '',
  site = site || {},
  generic = generic || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var oab_params =
    Drupal.settings.globals_variables.appointment_booking_privacy_policy !== 'undefined'
      ? Drupal.settings.globals_variables.appointment_booking_privacy_policy
      : 0;
  var time_interval =
    $('.appointment-select .col-heads').data('time-interval') ||
    Drupal.settings.globals_variables.appointment_booking_time_interval;
  var email_promotions =
    Drupal.settings.globals_variables.appointment_booking_email_promotions !== 'undefined'
      ? Drupal.settings.globals_variables.appointment_booking_email_promotions
      : 0;
  var start_day = Drupal.settings.globals_variables.appointment_booking_datepicker_start_day
    ? Drupal.settings.globals_variables.appointment_booking_datepicker_start_day
    : 0;
  var oab_date_show_week_text_at_first = Drupal.settings.globals_variables
    .oab_date_show_week_text_at_first
    ? Drupal.settings.globals_variables.oab_date_show_week_text_at_first
    : 0;
  var kr_legal_params = Drupal.settings.globals_variables.kr_legal_params
    ? Drupal.settings.globals_variables.kr_legal_params
    : 0;
  var settings = Drupal.settings.globals_variables || {};
  var oab_date_time_override = settings.oab_date_time_override || 0;
  var oab_hk_zh_dateformat_lang = settings.oab_hk_zh_dateformat_lang || 0;
  var oab_show_week_text_at_last = settings.oab_show_week_text_at_last || 0;
  var oabDateFormat = settings.oabDateFormat || 0;
  var email_signup_form_override = settings.email_signup_form_override || 0;
  var oab_email_signup_include_last_source = settings.oab_email_signup_include_last_source || 0;
  var oab_start_time_display = settings.oab_start_time_display || 0;
  var headernonSignedUser = $('.account_header_non_signed_user');
  var headerSignedUser = $('.account_header_signed_user');
  var phone1Input, phone2Input, apptKRPhoneCode, apptKrSelectPhoneCode;
  var oab_allow_mobile_pattern = settings.oab_allow_mobile_pattern || 0;
  var phone_code_format_change = settings.phone_code_format_change || 0;
  var appt_save_phone_code = settings.appt_save_phone_code || 0;
  var sms_enabled = settings.appt_sms_enabled || 0;
  var oab_my_sms_number_field = settings.oab_my_sms_number_field || 0;
  var do_not_submit_sms_pg_form = settings.do_not_submit_sms_pg_form || 0;
  var oab_book_counter_max = settings.oab_book_counter_max || 0;
  var appointment_booking_japan_date_format = settings.appointment_booking_japan_date_format || 0;

  /* optional day number override function used when we need to generate calendar table starting from monday; when global var start_day is not defined, output value is untouched */
  function startDayShift(day_nr) {
    day_nr = day_nr - start_day;
    if (day_nr == -1) {
      day_nr = 6;
    }

    return day_nr;
  }

  // padStart polyfill for IE11
  // https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
  if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength, padString) {
      targetLength = targetLength >> 0; // truncate if number or convert non-number to 0;
      padString = String(typeof padString !== 'undefined' ? padString : ' ');
      if (this.length > targetLength) {
        return String(this);
      } else {
        targetLength = targetLength - this.length;
        if (targetLength > padString.length) {
          // append to original to ensure we are longer than needed
          padString += Array.apply(null, Array(targetLength))
            .map(function () {
              return padString;
            })
            .join('');
        }

        return padString.slice(0, targetLength) + String(this);
      }
    };
  }

  var special_timeformat =
    Drupal.settings.globals_variables.oab_calendar_french_date_format !== 'undefined'
      ? Drupal.settings.globals_variables.oab_calendar_french_date_format
      : 0;
  var appt_use_counter_time_interval =
    Drupal.settings.globals_variables.appointment_booking_use_counter_time_interval !== 'undefined'
      ? Drupal.settings.globals_variables.appointment_booking_use_counter_time_interval
      : 0;
  var time_increment, counter_time_interval;

  /* Concrete View */
  apptBook.AppointmentSelectSection = function (container) {
    apptBook.AppointmentSelectSection.superclass.constructor.call(this);
    this.id = 'appointments';
    this.jqBod = $('body');
    this.container = container;
    this.servContainer = container.find('.services');
    this.serviceTmpl = this.servContainer.find('.service').remove();
    this.backTo = container.find('.back-to-link');
    this.minLabel = this.servContainer.attr('data-time-label');
    this.locSelect = container.find('select.location-select');
    this.locContainer = container.find('.selects-container');
    this.artContainer = container.find('.artist-select-container');
    this.artSelect = this.artContainer.find('select.artist-select');
    this.apptContainer = container.find('.appointment-select');
    this.signInContainer = container.find('.sign-in-container');
    this.headernonSignedUser = container.find('.account_header_non_signed_user');
    this.headerSignedUser = container.find('.account_header_signed_user');
    this.bookContainer = container.find('.book-appt-container');
    this.confContainer = container.find('.confirm-container');
    this.totalElem = this.confContainer.find('.total-time');
    this.totalText = this.totalElem.html();
    this.startOver = this.bookContainer.find('.start-over');
    this.selErrOverlay = container.find('.appt-book-services-overlay').remove();
    this.bookConflictOverlay = container.find('.appt-book-book-conflict-overlay').remove();
    this.calendarId = '0';
    this.bookCounterMax = container.find('.appt-book-book-countermax-overlay').remove();
    this.appointmentId = null;
    this.appointmentTime = null;
    this.totalTime = 0;
    this.totalTimeWithPadding = 0;
    this.serviceIds = [];
    this.stores = {};
    this.updateMode = false;
  };

  ctrlopt.extend(apptBook.AppointmentSelectSection, apptBook.AbstractSection);

  apptBook.AppointmentSelectSection.prototype.onUpdate = function (data) {
    var servs,
      servObj,
      hasCounter = false,
      hasCounters = false,
      me = this,
      aPgName = document.title + ' - Appointment Select & Book';

    this.serviceIds = [];
    this.totalTime = 0;
    this.updateMode = false;

    function runUpdate() {
      if (hasCounter && hasCounters) {
        me.buildServices();
        me.buildLocation();
        me.buildArtists();
        if (!me.initialized) {
          me.buildApptSelect();
          me.initialized = true;
        } else {
          me.calModel.update({
            date: new Date(),
            calendarId: me.calendarId,
            counterId: me.counterId,
            serviceIds: me.serviceIds,
            hilite: true
          });
        }
        me.buildBookAppt();
      }
    }

    function processUpdate() {
      if (data.params.appointmentId) {
        me.model.getAppointment(
          data.params.appointmentId,
          function (apptData) {
            me.appointmentData = apptData;
            me.updateMode = true;
            me.counterId = me.appointmentData.counter_id;
            me.calendarId = me.appointmentData.calendar_id;
            me.servicesData = [];
            me.appointmentId = apptData.id;
            me.appointmentTime = apptData.start_time;

            servs = me.appointmentData.services;

            for (var i = 0, len = servs.length; i < len; i += 1) {
              servObj = servs[i];
              me.servicesData.push({
                serviceId: servObj.id,
                serviceDuration: servObj.total_duration,
                serviceDurationWithPadding: servObj.total_duration_with_padding,
                serviceName: servObj.name
              });

              me.serviceIds.push(servObj.id);
            }

            me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
              me.counterData = data;
              hasCounter = true;
              runUpdate();
            });
          },
          function () {
            // If there is an error retrieving appointment id, go to beginning of APP
            var myUrl = [location.protocol, '//', location.host, location.pathname].join('');

            window.location = myUrl;
          }
        );
      } else {
        if (me.counterId !== data.params.counterId) {
          me.calendarId = '0';
        }
        if (data.params.updateMode) {
          me.updateMode = true;
          me.calendarId = '0';
        } else {
          me.updateMode = false;
        }
        me.counterId = data.params.counterId;
        me.servicesData = data.params.services;
        for (var i = 0, len = me.servicesData.length; i < len; i += 1) {
          me.serviceIds.push(me.servicesData[i].serviceId);
        }

        me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
          me.counterData = data;
          hasCounter = true;
          runUpdate();
        });
      }

      me.model.fetchCountersData({ service_id: this.serviceIds }, function (data) {
        me.countersData = data;
        hasCounters = true;
        runUpdate();
      });
    }

    if (data.sectionId === this.id) {
      generic.jsonrpc.fetch({
        method: 'user.json',
        params: [],
        onSuccess: function (jsonRpcResponse) {
          me.userData = jsonRpcResponse.getValue();
          processUpdate();
        },
        onFailure: function (jsonRpcResponse) {
          me.userData = null;
          processUpdate();
        }
      });
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildServices = function () {
    var myTmpl,
      sData,
      me = this;

    this.servContainer.find('.service').remove();
    for (var i = 0, len = this.servicesData.length; i < len; i += 1) {
      sData = this.servicesData[i];
      myTmpl = this.serviceTmpl.clone();
      this.servContainer.append(myTmpl);

      // if (site.client.isMobile) {
      // myTmpl.find('.service-head').text(sData.serviceName + " (" + sData.serviceDuration + " " + this.minLabel + ")");
      // } else {
      // myTmpl.find('.service-head').text(sData.serviceName);
      // myTmpl.find('.selection-time').text(sData.serviceDuration + " " + this.minLabel);
      // }

      myTmpl
        .find('.service-head')
        .append(
          sData.serviceName +
            ', ' +
            "<span class='selection-time'>" +
            sData.serviceDuration +
            ' ' +
            this.minLabel +
            '</span>'
        );

      myChangeServices = this.container.find('#change-services-link');

      this.totalTime += parseInt(sData.serviceDuration);
      this.totalTimeWithPadding += parseInt(sData.serviceDurationWithPadding);
      // this.serviceIds.push(sData.serviceId);

      function changeServSel(e) {
        e.preventDefault();

        var upObj = {
          sectionId: 'services',
          params: {
            sectionId: me.id,
            counterId: me.counterId,
            updateMode: me.updateMode
          }
        };

        me.model.update(upObj);
      }
      myChangeServices.off('click');
      myChangeServices.on('click', changeServSel);
      this.backTo.off('click');
      this.backTo.on('click', changeServSel);
    }

    if (!site.client.isMobile && this.servicesData.length > 1) {
      apptBook.equalHeights(this.servContainer.find('.service-head'));
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildLocation = function () {
    var me = this;
    // To determine if this appointment is virtual, see if the first service assigned to it is virtual.
    var apptServ = me.model.servicesData.filter(function (ele) {
      return parseInt(ele.id) === parseInt(me.servicesData[0].serviceId);
    })[0];
    var hasVirtual = parseInt(apptServ.virtual);

    function onLocChange(e) {
      var counterId = this.value,
        upObj = {
          sectionId: 'appointments',
          params: {
            counterId: counterId,
            services: me.servicesData,
            updateMode: me.updateMode
          }
        };

      if (counterId !== me.counterId) {
        me.model.update(upObj);
        site.track.evtLink({
          event_name: 'appointmentBooking_reselectLocation',
          event_category: 'appointment booking',
          event_action: 'reselect location',
          event_label: me.stores[counterId].store + ' - ' + me.stores[counterId].name
        });
      }
    }
    if (parseInt(hasVirtual)) {
      this.locContainer.find('.location-select').addClass('hidden');
      this.locContainer.find('.virtual-location').removeClass('hidden');
    } else {
      this.locSelect.find('option').remove();
      this.stores = {};
      for (var i = 0, len = this.countersData.length; i < len; i += 1) {
        // Exclude counters that do not support the services we have selected -- the user would get an error if they tried to pick those anyhow
        var excludeCounter = false;

        for (var j = 0; j < this.serviceIds.length; j++) {
          var servIdToCheck = parseInt(this.serviceIds[j]);
          var supportsService = false;

          for (var k = 0; k < this.countersData[i].service_ids.length; k++) {
            var counterServId = parseInt(this.countersData[i].service_ids[k]);

            if (servIdToCheck === counterServId) {
              supportsService = true;
            }
          }
          if (!supportsService) {
            excludeCounter = true;
            break;
          }
        }

        if (excludeCounter) {
          continue;
        }

        var storeName = this.countersData[i].name,
          optionText =
            this.countersData[i].town + ' - ' + storeName + ', ' + this.countersData[i].address1,
          optionValue = this.countersData[i].id,
          newOption = $('<option value="' + optionValue + '">' + optionText + '</option>'),
          storeNum = this.countersData[i].store_no,
          timeInterval =
            me.container.find('thead.col-heads').attr('data-time-interval') ||
            me.container.find('table.day').attr('data-time-interval'),
          tSlotInt = timeInterval || me.countersData[i].timeslot_interval;

        this.stores[optionValue] = {
          store: storeNum,
          name: storeName,
          tSlotInt: tSlotInt
        };

        if (optionValue === this.counterId) {
          newOption.prop('selected', true);
        }
        this.locSelect.append(newOption);
      }

      Drupal.ELB.refreshSelectBoxes(me.container.find('.selectbox, .selectBox'));
      // remove this first just in case we have already been to this screen
      this.locSelect.off('change');
      this.locSelect.on('change', onLocChange);
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildArtists = function () {
    var me = this,
      calData = this.counterData.calendars;

    // this.artContainer.css('display','block');
    this.artContainer.show();
    this.artSelect.find('option').remove();
    if (!calData || !calData.length) {
      this.launchSelErrOverlay();
      // this.artContainer.css('display','none');
      this.artContainer.hide();
    } else if (calData.length <= 1) {
      this.artContainer.hide();
    } else {
      for (var i = 0, len = calData.length; i < len; i += 1) {
        var optionText = calData[i].public_name,
          optionValue = calData[i].id,
          newOption = $('<option value="' + optionValue + '">' + optionText + '</option>');

        if (optionValue === this.calendarId) {
          newOption.prop('selected', true);
        }

        this.artSelect.append(newOption);
      }

      Drupal.ELB.refreshSelectBoxes(me.container.find('.selectbox, .selectBox'));
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildApptSelect = function () {
    var mOptions,
      vOptions,
      dpOptions,
      calDate,
      calTable,
      calHead,
      cHCont,
      colHeads,
      timeSlotsContainer,
      timeSlotRow,
      monthNames,
      dayNames,
      slotLabels,
      dpTrigger,
      dpField,
      dpOverlay,
      dpCalCont,
      dpCloseBtn,
      dp,
      dpMonthNames,
      dpDayNames,
      CalHeadView,
      CalTimeSlotsView,
      CalDatePicker,
      me = this;

    if (site.client.isMobile) {
      timeSlotsContainer = this.apptContainer.find('table.day');
      calHead = this.apptContainer.find('.calendar-head');
      timeSlotRow = timeSlotsContainer.find('tr').remove().first();
      slotLabels = timeSlotsContainer.attr('data-time-slots').split(',');
      if (this.apptContainer.find('.day').data('time-interval')) {
        slotLabels = timeSlotsContainer.attr('data-time-slots_extended').split(',');
      }

      dp = this.apptContainer.find('.date-picker');
      dpField = this.apptContainer.find('#appt-book-date-picker-field');
      dpCalCont = this.apptContainer.find('#appt-book-datepicker-calendar-container');
      dpMonthNames = dp.attr('data-months').split(',');
      dpDayNames = dp.attr('data-days').split(',');
      CalHeadView = apptBook.CalendarHeaderMobile;
      CalTimeSlotsView = apptBook.CalendarTimeSlotsMobile;
      CalDatePicker = apptBook.CalDatePickerMobile;
      time_interval = this.apptContainer.find('.day').data('time-interval') || time_interval;

      vOptions = {
        container: this.apptContainer,
        timeSlotsContainer: timeSlotsContainer,
        timeSlotRow: timeSlotRow,
        monthNames: monthNames,
        dayNames: dayNames,
        slotLabels: slotLabels
      };

      dpOptions = {
        calContainer: dpCalCont,
        datepickerField: dpField,
        monthNames: dpMonthNames,
        dayNames: dpDayNames
      };
    } else {
      calTable = this.apptContainer.find('.weekdays');
      calHead = this.apptContainer.find('.calendar-head');
      cHCont = calTable.find('thead.col-heads');
      colHeads = cHCont.find('th');
      timeSlotsContainer = calTable.find('tbody.timeslots');
      timeSlotRow = timeSlotsContainer.find('tr').remove().first();
      monthNames = cHCont.attr('data-months').split(',');
      dayNames = cHCont.attr('data-days').split(',');
      slotLabels = cHCont.attr('data-time-slots').split(',');
      if (this.apptContainer.find('.col-heads').data('time-interval')) {
        slotLabels = cHCont.attr('data-time-slots_extended').split(',');
      }
      dpTrigger = calHead.find('#appt-book-date-picker-trigger');
      dpField = calHead.find('#appt-book-date-picker-field');
      dpOverlay = this.container.find('#appt-book-datepicker-overlay').remove();
      dpCalCont = dpOverlay.find('#appt-book-datepicker-calendar-container');
      dpCloseBtn = dpOverlay.find('.overlay-close');
      dpMonthNames = dpTrigger.attr('data-months').split(',');
      dpDayNames = dpTrigger.attr('data-days').split(',');
      /* dpMonthNames = calHead.attr('data-months').split(',');
      dpDayNames = dayNames;*/
      CalHeadView = apptBook.CalendarHeader;
      CalTimeSlotsView = apptBook.CalendarTimeSlots;
      CalDatePicker = apptBook.CalDatePicker;

      vOptions = {
        container: this.apptContainer,
        colHeads: colHeads,
        timeSlotsContainer: timeSlotsContainer,
        timeSlotRow: timeSlotRow,
        monthNames: monthNames,
        dayNames: dayNames,
        slotLabels: slotLabels
      };

      dpOptions = {
        overlay: dpOverlay,
        closeBtn: dpCloseBtn,
        calContainer: dpCalCont,
        weekContainer: calHead,
        datepickerField: dpField,
        datepickerTrigger: dpTrigger,
        monthNames: dpMonthNames,
        dayNames: dpDayNames,
        jqBod: this.jqBod
      };
    }

    mOptions = {
      dataModel: this.model,
      launchOverlayCallback: this.launchSelErrOverlay.bind(this),
      counterId: this.counterId,
      appointmentDuration: this.totalTime,
      appointmentDurationWithPadding: this.totalTimeWithPadding,
      serviceIds: this.serviceIds
    };

    this.calModel = new apptBook.CalendarModel();
    this.calModel.setData(mOptions);
    this.calTimeSlots = new CalTimeSlotsView(vOptions);
    this.calHeadView = new CalHeadView(calHead);
    this.calTimeSlots.setModel(this.calModel).startObserving();
    this.calHeadView.setModel(this.calModel).startObserving();

    this.datePicker = new CalDatePicker(dpOptions);
    this.datePicker.setModel(this.calModel);

    this.artSelect.on('change', function (e) {
      var calId = this.value,
        calName = this.options[this.selectedIndex].text;

      if (calId !== me.calendarId) {
        me.calModel.update({ calendarId: calId });
        me.calendarId = calId;
      }
    });

    calDate = this.appointmentTime
      ? this.calTimeSlots.convertTimeString(this.appointmentTime)
      : new Date();
    this.calModel.update({
      date: calDate,
      hilite: true,
      calendarId: this.calendarId,
      appointmentTime: this.appointmentTime
    });
  };

  apptBook.AppointmentSelectSection.prototype.buildBookAppt = function () {
    var totText,
      area_code,
      apptUseKRMobileNumberFields,
      me = this,
      signIn = this.signInContainer.find('#appt-book-sign-in-form-container'),
      signInLink = this.signInContainer.find('#appt-book-sign-in-link').off('click'),
      loginEmail = this.signInContainer.find('#appt-book-login-email'),
      pw = this.signInContainer.find('#appt-book-login-password'),
      signInBtn = signIn.find('#appt-book-login-submit').off('click'),
      fbsignInBtn = signIn.find('#appt-book-fblogin-submit').off('click'),
      apptFbbtn = $('.js-appt-fb-login-button'),
      bookBtn = this.confContainer.find('#appt-book-book-submit').off('click'),
      fNameInput = this.bookContainer.find('.appt-book-first-name'),
      lNameInput = this.bookContainer.find('.appt-book-last-name'),
      emailInput = this.bookContainer.find('.appt-book-email'),
      phoneInput = this.bookContainer.find('.appt-book-mobile'),
      krFormat = this.bookContainer.find('#js_appt_use_kr_mobile_number_fields'),
      phoneCodeInput = me.bookContainer.find('.js-appt-hk-phone-code'),
      commentsInput = this.bookContainer.find('.appt-book-note'),
      privacyInput = this.bookContainer.find('.appt-book-privacy-policy'),
      termsCommercialInput = this.bookContainer.find('.appt-book-terms-commercial'),
      signUpEmailInput = this.bookContainer.find('.registration__email-list').find('input'),
      signUpSMSInput = this.bookContainer.find('.registration__sms-list').find('input'),
      signUpPrivacyInput = this.bookContainer
        .find('.registration__privacy-policy-list')
        .find('input'),
      signUpTermsCommercialInput = this.bookContainer
        .find('.registration__commercial-list')
        .find('input'),
      signUpLoyaltyInput = this.bookContainer.find('.regristration_loyalty-list').find('input'),
      acceptedPrivacyPolicy = this.bookContainer.find('input[name="ACCEPTED_PRIVACY_POLICY"]'),
      oabSMSOptin = this.bookContainer.find('input[name="APPT_SMS_NOTIFICATIONS"]'),
      pcEmailPromotions = this.bookContainer.find('input[name="PC_EMAIL_PROMOTIONS"]'),
      smsPromotions = this.bookContainer.find('input[name="SMS_PROMOTIONS"]'),
      postalPromotions = this.bookContainer.find('input[name="POSTAL_PROMOTIONS"]'),
      acceptTermsHead = this.bookContainer.find('.accept-terms-head'),
      acceptoabSMSHead = this.bookContainer.find('.accept-oab-sms-head'),
      acceptPrivacyHead = this.bookContainer.find('.accept-privacy-head'),
      acceptEmailHead = this.bookContainer.find('.accept-email-head'),
      acceptSMSHead = this.bookContainer.find('.accept-sms-head'),
      acceptPostalHead = this.bookContainer.find('.accept-postal-head'),
      errorContainer = this.container.find('#appt-book-confirm-error-messages'),
      errorMessages = errorContainer.find('.error-message'),
      emailCheckboxLabel = this.bookContainer.find('.registration__email-list').find('span'),
      privacyCheckboxLabel = this.bookContainer
        .find('.registration__privacy-policy-list')
        .find('span'),
      termsCommercialCheckboxLabel = this.bookContainer
        .find('.registration__commercial-list')
        .find('span'),
      headernonSignedUser = this.container.find('.account_header_non_signed_user'),
      headerSignedUser = this.container.find('.account_header_signed_user'),
      countryCode = this.bookContainer.find('#js_country_code'),
      populateKRPhoneField,
      populateMobilePhoneWithPrefix,
      mobileParts;

    sms_enabled = this.bookContainer.data('enableSms') ? this.bookContainer.data('enableSms') : sms_enabled;
    apptUseKRMobileNumberFields = krFormat.text() ? parseInt(krFormat.text()) : 0;

    if (apptUseKRMobileNumberFields) {
      phone1Input = this.bookContainer.find('.js_appt_mobile_part1');
      phone2Input = this.bookContainer.find('.js_appt_mobile_part2');
      apptKRPhoneCode = this.bookContainer.find('.js_appt_kr_phone_code');
      var apptPhoneCode = this.bookContainer.find('#js_appt_phone_codes');

      apptPhoneCode = apptPhoneCode.text();
      apptKrSelectPhoneCode = this.bookContainer.find('select.js_appt_kr_phone_code');
      var apptPhoneCodeSplit = apptPhoneCode.split(',');
      var codeOptions;

      $.each(apptPhoneCodeSplit, function (i, val) {
        codeOptions = $('<option></option>', {
          value: val,
          text: val
        });
        apptKRPhoneCode.append(codeOptions);
      });
    }
    if (Drupal && Drupal.settings && Drupal.settings.fb_login_app_id && site.facebook) {
      site.facebook.init();
      apptFbbtn.attr('onlogin', 'fbsignInBtn.click();');
    }
    this.startOver.off('click');
    this.startOver.on('click', function () {});
    if (phone_code_format_change) {
      var apptPhoneCodeHK = me.bookContainer.find('.js-phone-codes-hk');

      apptPhoneCodeHK = apptPhoneCodeHK.text();
      var apptHKPhoneCode = me.bookContainer.find('select.js-appt-hk-phone-code');
      var apptPhoneCodeSplitHK = apptPhoneCodeHK.split(',');
      var codeOptionsHK;

      $.each(apptPhoneCodeSplitHK, function (i, val) {
        codeOptionsHK = $('<option></option>', {
          value: val,
          text: '+' + val
        });
        apptHKPhoneCode.append(codeOptionsHK);
      });
    }
    fNameInput.keyup(function (e) {
      var maxlength = fNameInput.attr('data-placeholder-maxlength');

      if (!!maxlength) {
        var text = fNameInput.val();

        if (text.length > maxlength) {
          fNameInput.val(text.substring(0, maxlength));
          e.preventDefault();
        }
      }
    });

    lNameInput.keyup(function (e) {
      var maxlength = lNameInput.attr('data-placeholder-maxlength');

      if (!!maxlength) {
        var text = lNameInput.val();

        if (text.length > maxlength) {
          lNameInput.val(text.substring(0, maxlength));
          e.preventDefault();
        }
      }
    });

    commentsInput.keyup(function (e) {
      var maxlength = commentsInput.attr('maxlength');

      if (!!maxlength) {
        var text = commentsInput.val();

        if (text.length > maxlength) {
          commentsInput.val(text.substring(0, maxlength));
          e.preventDefault();
        }
      }
    });

    populateKRPhoneField = function (mobilePhone) {
      mobileParts = (/^(\d{3})-?(\d{4})-?(\d*)$/gu).exec(mobilePhone);
      if (mobileParts && mobileParts[1] && mobileParts[2] && mobileParts[3]) {
        apptKRPhoneCode.val(mobileParts[1]);
        phone1Input.val(mobileParts[2]);
        phone2Input.val(mobileParts[3]);
      }
    };

    populateMobilePhoneWithPrefix = function (mobilePhone) {
      mobileParts = (/^(\d+)-(\d*)$/gu).exec(mobilePhone);
      if (mobileParts && mobileParts[1] && mobileParts[2]) {
        me.bookContainer.find('select.js-appt-hk-phone-code').val(mobileParts[1]);
        phoneInput.val(mobileParts[2]);
      }
    };

    phoneInput.keydown(function (e) {
      var key = e.charCode || e.keyCode || 0;

      // Allow numeric (and tab, backspace, delete) keys only
      return (
        key == 8 || key == 9 || key == 46 || (key >= 48 && key <= 57) || (key >= 96 && key <= 105)
      );
    });

    phoneInput.keyup(function (e) {
      var $this = $(this);
      var maxlength = $this.attr('data-placeholder-maxlength');

      if (!!maxlength) {
        var text = $this.val();

        if (text.length > maxlength) {
          $this.val(text.substring(0, maxlength));
          e.preventDefault();
        }
      }
    });
    loginEmail.val('');
    pw.val('');
    emailInput.val('').prop('disabled', false);
    commentsInput.val('');
    this.totalElem.empty();

    if (this.userData && this.userData.signed_in) {
      this.signInContainer.css('display', 'none');
      this.headerSignedUser.removeClass('hidden');
      this.headernonSignedUser.addClass('hidden');

      if (this.userData.first_name) {
        fNameInput.val(this.userData.first_name);
      }

      if (this.userData.last_name) {
        lNameInput.val(this.userData.last_name);
      }

      emailInput.val(this.userData.email_address).prop('disabled', true);

      if (this.userData.mobile_phone) {
        if (apptUseKRMobileNumberFields) {
          populateKRPhoneField(this.userData.mobile_phone);
        } else if (phone_code_format_change) {
          populateMobilePhoneWithPrefix(this.userData.mobile_phone);
        } else {
          phoneInput.val(this.userData.mobile_phone);
        }
      }

      if (site.client.isMobile) {
        if (this.userData.mobile_email_optin || this.userData.pc_email_optin) {
          signUpEmailInput.prop('checked', true);
        } else {
          signUpEmailInput.prop('checked', false);
        }
      } else {
        if (this.userData.pc_email_optin) {
          signUpEmailInput.prop('checked', true);
        } else {
          signUpEmailInput.prop('checked', false);
        }
      }

      if (this.userData.sms_optin) {
        signUpSMSInput.prop('checked', true);
      } else {
        signUpSMSInput.prop('checked', false);
      }
    } else {
      this.signInContainer.css('display', 'block');
      this.headernonSignedUser.removeClass('hidden');
      this.headerSignedUser.addClass('hidden');
    }

    totText = this.totalText + ' ' + this.totalTime + ' ' + this.minLabel;
    this.totalElem.html(totText);

    this.calModel.on('time_selected', function (data) {
      bookBtn.removeClass('disabled');
    });

    this.calModel.on('time_deselected', function (data) {
      bookBtn.addClass('disabled');
    });

    signInLink.on('click', function (e) {
      e.preventDefault();
      signIn.hide().slideDown(1000, function () {
        setSignIn();
      });
    });

    window.fbsignInBtn = fbsignInBtn;

    function setSignIn() {
      fbsignInBtn.once().on('click', function () {
        var token = null,
          $this = $(this),
          params = [],
          last_source = null,
          pc_email_promotions = 0,
          $optInFormInput = $('#form--facebook_signin--field--PC_EMAIL_PROMOTIONS');

        if ($this.hasClass('disabled')) {
          return;
        }

        last_source = 'appointment_booking';
        pc_email_promotions = $optInFormInput.is(':checked') ? 1 : 0;

        FB.getLoginStatus(function (response) {
          statusChangeCallback(response);
        });
        if (typeof FB === 'object') {
          FB.getLoginStatus(function (response) {
            statusChangeCallback(response);
          });
        }

        function statusChangeCallback(response) {
          if (FB.getAuthResponse()) {
            token = response.authResponse.accessToken;
            rpccall();
          }
        }

        function rpccall() {
          $this.addClass('disabled');
          params.push({
            _SUBMIT: 'facebook_signin',
            token: token,
            LAST_SOURCE: last_source,
            PC_EMAIL_PROMOTIONS: pc_email_promotions
          });

          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: JSON.stringify(params),
            onSuccess: function (jsonRpcResponse) {
              var h,
                rData = jsonRpcResponse.getData().userinfo;

              me.model.updateAuthToken(function () {
                $this.removeClass('disabled');
                emailInput.val(rData.email_address).prop('disabled', true);

                if (rData.first_name) {
                  fNameInput.val(rData.first_name);
                }
                if (rData.last_name) {
                  lNameInput.val(rData.last_name);
                }
                if (rData.mobile_phone) {
                  if (apptUseKRMobileNumberFields) {
                    populateKRPhoneField(rData.mobile_phone);
                  } else if (phone_code_format_change) {
                    populateMobilePhoneWithPrefix(rData.mobile_phone);
                  } else {
                    phoneInput.val(rData.mobile_phone);
                  }
                }

                if (site.client.isMobile) {
                  if (rData.mobile_email_optin) {
                    signUpEmailInput.prop('checked', true);
                  } else {
                    signUpEmailInput.prop('checked', false);
                  }
                } else {
                  if (rData.pc_email_optin) {
                    signUpEmailInput.prop('checked', true);
                  } else {
                    signUpEmailInput.prop('checked', false);
                  }
                }

                if (rData.sms_optin) {
                  signUpSMSInput.prop('checked', true);
                } else {
                  signUpSMSInput.prop('checked', false);
                }

                fNameInput.focus();

                me.userData = rData;
              });

              errorContainer.css('display', 'none');
              errorMessages.css('display', 'none');
              pw.removeClass('error');
              loginEmail.removeClass('error');

              $this.removeClass('disabled');

              signInLink.css('display', 'inline-block');

              h = signIn.css('height');
              signIn.animate({ height: 0 }, 1000, function () {
                signIn.css('display', 'none');
                signIn.height(h);
                me.signInContainer.css('display', 'none');
              });
            },
            onFailure: function (jsonRpcResponse) {
              var errObjs = jsonRpcResponse.getMessages();

              errorContainer.css('display', 'block');
              errorMessages.css('display', 'none');
              pw.removeClass('error');
              me.bookContainer.addClass('guest');
              loginEmail.removeClass('error');
              for (var i = 0; i < errObjs.length; i += 1) {
                var myErr = errObjs[i];

                if (myErr && myErr.key) {
                  switch (myErr.key) {
                    case 'required.password.signin':
                    case 'invalid.password.signin':
                      pw.addClass('error');
                      errorMessages.filter('#error-signin-password').css('display', 'block');
                      break;
                    case 'required_or.email_address.device_id.required_or.signin':
                    case 'required.email_address.signin':
                    case 'invalid.email_address.signin':
                      loginEmail.addClass('error');
                      errorMessages.filter('#error-signin-email').css('display', 'block');
                      break;
                    case 'no_account.signin':
                      loginEmail.addClass('error');
                      pw.addClass('error');
                      errorMessages.filter('#error-signin-no-account').css('display', 'block');
                      break;
                    case 'social_fb_no_email':
                    case 'social_fb_no_email.app':
                    case 'social_duplicate_account_links':
                    case 'social_duplicate_account_links.app':
                    case 'signin_error2':
                    case 'signin_error2.app':
                      errorMessages
                        .filter('#error-others')
                        .css('display', 'block')
                        .text(myErr.text);
                      break;
                    default:
                      break;
                  }
                }
              }
              $this.removeClass('disabled');
            }
          });
        }
      });
      signInBtn.on('click', function (e) {
        e.preventDefault();
        var $this = $(this),
          params = [];

        if ($this.hasClass('disabled')) {
          return;
        }

        $this.addClass('disabled');
        params.push({
          _SUBMIT: 'signin',
          EMAIL_ADDRESS: loginEmail.val(),
          PASSWORD: pw.val()
        });

        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: JSON.stringify(params),
          onSuccess: function (jsonRpcResponse) {
            var h,
              rData = jsonRpcResponse.getData().userinfo;

            me.model.updateAuthToken(function () {
              $this.removeClass('disabled');
              emailInput.val(rData.email_address).prop('disabled', true);

              if (rData.first_name) {
                fNameInput.val(rData.first_name);
              }
              if (rData.last_name) {
                lNameInput.val(rData.last_name);
              }
              if (rData.mobile_phone) {
                if (apptUseKRMobileNumberFields) {
                  populateKRPhoneField(rData.mobile_phone);
                } else if (phone_code_format_change) {
                  populateMobilePhoneWithPrefix(rData.mobile_phone);
                } else {
                  phoneInput.val(rData.mobile_phone);
                }
              }

              if (site.client.isMobile) {
                if (rData.mobile_email_optin) {
                  signUpEmailInput.prop('checked', true);
                } else {
                  signUpEmailInput.prop('checked', false);
                }
              } else {
                if (rData.pc_email_optin) {
                  signUpEmailInput.prop('checked', true);
                } else {
                  signUpEmailInput.prop('checked', false);
                }
              }

              if (rData.sms_optin) {
                signUpSMSInput.prop('checked', true);
              } else {
                signUpSMSInput.prop('checked', false);
              }

              fNameInput.focus();

              me.userData = rData;
            });

            errorContainer.css('display', 'none');
            errorMessages.css('display', 'none');
            pw.removeClass('error');
            loginEmail.removeClass('error');

            $this.removeClass('disabled');
            headerSignedUser.removeClass('hidden');
            headernonSignedUser.addClass('hidden');
            signInLink.css('display', 'inline-block');

            h = signIn.css('height');
            signIn.animate({ height: 0 }, 1000, function () {
              signIn.css('display', 'none');
              signIn.height(h);
              me.signInContainer.css('display', 'none');
            });
          },
          onFailure: function (jsonRpcResponse) {
            var errObjs = jsonRpcResponse.getMessages();

            errorContainer.css('display', 'block');
            errorMessages.css('display', 'none');
            pw.removeClass('error');
            loginEmail.removeClass('error');
            headernonSignedUser.removeClass('hidden');
            headerSignedUser.addClass('hidden');
            for (var i = 0; i < errObjs.length; i += 1) {
              var myErr = errObjs[i];

              if (myErr && myErr.key) {
                if (myErr.key === 'required.password.signin') {
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-password').css('display', 'block');
                }

                if (myErr.key === 'invalid.password.signin') {
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-password').css('display', 'block');
                }

                if (myErr.key === 'required_or.email_address.device_id.required_or.signin') {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (myErr.key === 'required.email_address.signin') {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (myErr.key === 'invalid.email_address.signin') {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (myErr.key === 'no_account..signin') {
                  loginEmail.addClass('error');
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-no-account').css('display', 'block');
                }
              }
            }

            $this.removeClass('disabled');
          }
        });
      });
    }

    bookBtn.on('click', onSubmitBooking);

    function onSubmitBooking(e) {
      e.preventDefault();
      var params = {},
        signUpEmailParams = [],
        signUpEmailObj = {},
        fName = fNameInput.val(),
        lName = lNameInput.val(),
        email = emailInput.val(),
        phone = phoneInput.val(),
        signUpEmail = signUpEmailInput.is(':checked') ? signUpEmailInput.val() : 0,
        signUpSMS = signUpSMSInput.is(':checked') ? signUpSMSInput.val() : 0,
        signUpPrivacy = signUpPrivacyInput.is(':checked') ? signUpPrivacyInput.val() : 0,
        commercialTerms = signUpTermsCommercialInput.is(':checked')
          ? signUpTermsCommercialInput.val()
          : 0,
        loyaltyTerms = signUpLoyaltyInput.is(':checked') ? signUpLoyaltyInput.val() : 0,
        loyaltyPromotion = 0,
        signUpEmailDone = false,
        signUpSMSDone = false,
        comments = commentsInput.val(),
        $this = $(this),
        isEmptyField = 0,
        requireTermsForSMS = oabSMSOptin.length ? 1 : 0,
        oabSMSOptinValue,
        isArray = me.serviceIds instanceof Array;

      if ($this.hasClass('disabled')) {
        return;
      }

      errorContainer.css('display', 'block');
      errorMessages.css('display', 'none');
      me.container.find('input, textarea, .label, .picker-handle, label').removeClass('error');
      emptyInputs();
      if (isEmptyField) {
        $this.removeClass('disabled');

        return;
      }
      $this.addClass('disabled');

      params = {
        counter_id: me.counterId,
        calendar_id: me.calendarId,
        appointment_service_id: me.serviceIds,
        start_time: me.calModel.getSelection().selectionString,
        customer_first_name: fName,
        customer_last_name: lName,
        customer_email: email
      };

      site.track.evtLink({
        event_name: 'appointmentBooking_DateTime',
        event_category: 'appointment booking',
        event_action: 'Date and Time Picked',
        event_label:
          me.counterData.store_no + ' - ' + me.counterData.name + ' - ' + params.start_time
      });

      site.track.evtLink({
        event_name: 'appointmentBooking_bookNow',
        event_category: 'appointment booking',
        event_action: 'bookNow',
        event_label:
          me.counterData.store_no + ' - ' + me.counterData.name + ' - ' + params.start_time
      });

      if (comments) {
        params.customer_comments = comments;
      }

      if (apptUseKRMobileNumberFields) {
        area_code = apptKrSelectPhoneCode.val();
        if (area_code) {
          area_code = area_code.substr(1, 2);
        }
        params.customer_phone =
          countryCode.text() + area_code + phone1Input.val() + phone2Input.val();
      } else if (phone) {
        // making sure we pass phone number stripped from any dashes, brackets and leading zeros
        params.customer_phone = phone.replace(/\(|\)|-/gi, '');
        params.customer_phone = params.customer_phone.replace(/^(0)(\d+)$/, '$2');
        if (appt_save_phone_code) {
          params.customer_phone = phoneCodeInput.val() + params.customer_phone;
        } else {
          params.customer_phone = countryCode.text() + params.customer_phone;
        }
      }

      if (requireTermsForSMS) {
        if (oabSMSOptin.attr('type') === 'checkbox') {
          oabSMSOptinValue = oabSMSOptin.is(':checked') ? 1 : 0;
        } else {
          oabSMSOptinValue = oabSMSOptin.is(':checked') ? oabSMSOptin.filter(':checked').val() : 0;
        }
      }
      if (sms_enabled) {
        if (requireTermsForSMS) {
          params.sms_notifications_enabled = parseInt(oabSMSOptinValue);
        } else {
          params.sms_notifications_enabled = 1;
        }
      }

      function emptyInputs() {
        var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
        var phone_maxlength = phoneInput.attr('maxlength');
        var phone_regex = new RegExp(phoneInput.attr('pattern'));
        var acceptedPrivacyPolicyValue = $('input[name="ACCEPTED_PRIVACY_POLICY"]:checked').val();
        var phone1_regex, phone2_regex;

        if (apptUseKRMobileNumberFields) {
          phone1_regex = new RegExp(phone1Input.attr('pattern'));
          phone2_regex = new RegExp(phone2Input.attr('pattern'));
        }
        var phone_validation =
          oab_allow_mobile_pattern && appt_save_phone_code
            ? !phone_regex.test(phoneCodeInput.val() + phone)
            : phone_regex && !phone_regex.test(phone);

        if (!fNameInput.val()) {
          errorMessages.filter('#error-book-first-name').css('display', 'block');
          fNameInput.addClass('error');
          isEmptyField = 1;
        }
        if (!$(lNameInput.parent()).hasClass('js-no-last-name') && !lNameInput.val()) {
          errorMessages.filter('#error-book-last-name').css('display', 'block');
          lNameInput.addClass('error');
          isEmptyField = 1;
        }
        if (!emailInput.val() || !testEmail.test(emailInput.val())) {
          errorMessages.filter('#error-book-email').css('display', 'block');
          emailInput.addClass('error');
          isEmptyField = 1;
        }
        if (signUpPrivacyInput.length && !signUpPrivacyInput.is(':checked')) {
          errorMessages.filter('#error-signup-privacy').css('display', 'block');
          privacyInput.addClass('error');
          privacyCheckboxLabel.addClass('error');
          isEmptyField = 1;
        }
        if (signUpTermsCommercialInput.length && !signUpTermsCommercialInput.is(':checked')) {
          errorMessages.filter('#error-signup-commercial').css('display', 'block');
          termsCommercialInput.addClass('error');
          termsCommercialCheckboxLabel.addClass('error');
          isEmptyField = 1;
        }
        if (apptUseKRMobileNumberFields) {
          if (!apptKrSelectPhoneCode.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          } else {
            apptKRPhoneCode.removeClass('error');
          }
          if (phone1Input.val()) {
            if (phone1_regex && !phone1_regex.test(phone1Input.val())) {
              errorMessages.filter('#error-book-mobile').css('display', 'block');
              errorMessages.filter('#error-book-mobile_part1_invalid').css('display', 'block');
              apptKRPhoneCode.addClass('error');
              phone1Input.addClass('error');
              phone2Input.addClass('error');
              isEmptyField = 1;
            }
          } else if (!phone1Input.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          }
          if (phone2Input.val()) {
            if (phone2_regex && !phone2_regex.test(phone2Input.val())) {
              errorMessages.filter('#error-book-mobile').css('display', 'block');
              errorMessages.filter('#error-book-mobile_part2_invalid').css('display', 'block');
              apptKRPhoneCode.addClass('error');
              phone1Input.addClass('error');
              phone2Input.addClass('error');
              isEmptyField = 1;
            }
          } else if (!phone2Input.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          }
          if (!acceptedPrivacyPolicy.is(':checked') || acceptedPrivacyPolicyValue === '0') {
            errorMessages.filter('#error-terms-conditions').css('display', 'block');
            acceptTermsHead.addClass('error');
            isEmptyField = 1;
          } else {
            acceptTermsHead.removeClass('error');
          }
          if (!oabSMSOptin.is(':checked')) {
            errorMessages.filter('#error-oab-sms').css('display', 'block');
            acceptoabSMSHead.addClass('error');
            isEmptyField = 1;
          } else {
            acceptoabSMSHead.removeClass('error');
          }
          if (!pcEmailPromotions.is(':checked')) {
            errorMessages.filter('#error-marketing-channels').css('display', 'block');
            acceptEmailHead.addClass('error');
            isEmptyField = 1;
          } else {
            acceptEmailHead.removeClass('error');
          }
          if (!smsPromotions.is(':checked')) {
            errorMessages.filter('#error-marketing-channels').css('display', 'block');
            acceptSMSHead.addClass('error');
            isEmptyField = 1;
          } else {
            acceptSMSHead.removeClass('error');
          }
          if (!postalPromotions.is(':checked')) {
            errorMessages.filter('#error-marketing-channels').css('display', 'block');
            acceptPostalHead.addClass('error');
            isEmptyField = 1;
          } else {
            acceptPostalHead.removeClass('error');
          }
          if (
            !pcEmailPromotions.is(':checked') ||
            !smsPromotions.is(':checked') ||
            !postalPromotions.is(':checked')
          ) {
            acceptPrivacyHead.addClass('error');
            errorMessages.filter('#error-marketing-channels').css('display', 'block');
          } else {
            acceptPrivacyHead.removeClass('error');
          }
        } else {
          if (!phoneInput.val() && errorMessages.filter('#error-signup-sms').is(':hidden')) {
            errorMessages.filter('#error-book-phone').css('display', 'block');
            phoneInput.addClass('error');
            isEmptyField = 1;
          } else if (phone_validation) {
            var phone_format_length = phoneInput.attr('length');

            if (phone_format_length !== phone.length) {
              errorMessages.filter('#error-book-phone-format').css('display', 'block');
              phoneInput.addClass('error');
            }
            errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
            phoneInput.addClass('error');
            isEmptyField = 1;
          }
        }
      }

      function onBookSuccess(r) {
        var updateData,
          apptId = r.id;

        site.track.evtView({
          page_url: '/book-appointment/complete',
          location: location.origin + '/book-appointment/complete',
          page_name: 'Book Appointment - Complete'
        });

        site.track.evtLink({
          event_name: 'appointmentBooking_complete',
          event_category: 'appointment booking',
          event_action: 'appointment booked',
          event_label: r.counter.store_no + ' - ' + r.counter.name + ' - ' + r.start_time
        });

        updateData = {
          sectionId: 'next',
          params: r
        };
        me.model.update(updateData);
        $this.addClass('disabled');
        errorMessages.css('display', 'none');
        errorContainer.css('display', 'none');
        me.container.find('input').removeClass('error');
        me.container.find('textarea').removeClass('error');
      }

      function onBookError(r) {
        $this.removeClass('disabled');

        var errFName = r.customer_first_name,
          errLName = r.customer_last_name,
          errEmail = r.customer_email,
          errPhone = r.customer_phone,
          errComments = r.customer_comments;

        errorContainer.css('display', 'block');
        errorMessages.css('display', 'none');

        if (r.code === 500 || r.code === '500') {
          me.launchBookConflictOverlay();

          return;
        }
        if (oab_book_counter_max) {
          if (errorCounterMax && errorCounterMax.length) {
            me.launchCounterMaxOverlay();

            return;
          }
        }
        var errorShown = false;

        if (errFName && errFName.length) {
          errorMessages.filter('#error-book-first-name').css('display', 'block');
          fNameInput.addClass('error');
          errorShown = true;
        }
        if (errLName && errLName.length) {
          errorMessages.filter('#error-book-last-name').css('display', 'block');
          lNameInput.addClass('error');
          errorShown = true;
        }
        if (errEmail && errEmail.length) {
          errorMessages.filter('#error-book-email').css('display', 'block');
          emailInput.addClass('error');
          errorShown = true;
        }
        if (errPhone && errPhone.length) {
          errorMessages.filter('#error-book-phone').css('display', 'block');
          phoneInput.addClass('error');
          errorShown = true;
        }
        if (errComments && errComments.length) {
          errorMessages.filter('#error-book-comments').css('display', 'block');
          commentsInput.addClass('error');
          errorShown = true;
        }
        // Unhandled error should still show the user something
        if (!errorShown) {
          me.launchBookConflictOverlay();
        }
      }

      function loyaltyJoin() {
        var params = {
          _SUBMIT: 'loyalty_join',
          LOYALTY_ACTIVE_FLAG: '1',
          LOYALTY_ACTIVE_FLAG_PRESENT: '1',
          COMMERCIAL_PERMISSION: '1',
          DATA_PRIVACY_CONSENT: '1',
          PC_EMAIL_ADDRESS: email,
          PC_EMAIL_PROMOTIONS: '1'
        };

        if ($.cookie('csrftoken')) {
          params._TOKEN = $.cookie('csrftoken');
        }
        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: [params],
          onSuccess: function (jsonRpcResponse) {
            signUpEmailDone = true;
            doBooking();
          }
        });
      }

      function doBooking() {
        errorMessages.css('display', 'none');
        me.container.find('input, textarea, .label, .picker-handle').removeClass('error');

        if (isEmptyField) {
          $this.removeClass('disabled');
        } else if (me.updateMode && me.appointmentId) {
          me.model.changeAppointment(me.appointmentId, params, onBookSuccess, onBookError);
        } else {
          me.model.bookAppointment(params, onBookSuccess, onBookError);
        }
      }

      signUpEmailObj._SUBMIT = email_signup_form_override ? 'email_signup_oab' : 'email_signup';
      signUpEmailObj.EMAIL_ADDRESS = email;
      signUpEmailObj.PC_EMAIL_ADDRESS = email;
      if (oab_email_signup_include_last_source) {
        signUpEmailObj.LAST_SOURCE = 'appointment_booking';
        signUpEmailObj.ORIGINAL_SOURCE = 'appointment_booking';
      }
      if (kr_legal_params) {
        signUpEmailObj.ACTION = '';
      } else {
        if (!signUpEmail && me.userData.recognized_user) {
          signUpEmailObj.ACTION = 'unset';
        }
      }
      if (kr_legal_params) {
        if (smsPromotions) {
          signUpEmailObj.MOBILE_NUMBER =
            apptKrSelectPhoneCode.val() + '-' + phone1Input.val() + '-' + phone2Input.val();
        }
        var smsPromotionsValue = $('input[name="SMS_PROMOTIONS"]:checked').val();
        var pcEmailPromotionsValue = $('input[name="PC_EMAIL_PROMOTIONS"]:checked').val();
        var postalPromotionsValue = $('input[name="POSTAL_PROMOTIONS"]:checked').val();
        signUpEmailObj.SMS_PROMOTIONS = smsPromotionsValue;
        signUpEmailObj.PC_EMAIL_PROMOTIONS = pcEmailPromotionsValue;
        signUpEmailObj.POSTAL_PROMOTIONS = postalPromotionsValue;
      } else {
        if (commercialTerms) {
          signUpEmailObj.DATA_PRIVACY_CONSENT = commercialTerms;
          signUpEmailObj.COMMERCIAL_PERMISSION = commercialTerms;
          signUpEmailObj.MOBILE_NUMBER = phone;
          signUpSMS = 0;
        }
        if (loyaltyTerms) {
          loyaltyPromotion = 1;
        }

        if (signUpSMS && (!me.userData || !me.userData.sms_optin)) {
          signUpEmailObj._SECONDARY_SUBMIT = 'sms';
          signUpEmailObj.SMS_PROMOTIONS = 1;
          if (oab_my_sms_number_field) {
            signUpEmailObj.PHONE2 = phone;
            signUpEmailObj.PHONE2_TYPE = 2;
          } else {
            signUpEmailObj.MOBILE_PHONE = phone;
          }
        }
      }
      if (!commercialTerms) {
        if (!kr_legal_params && !do_not_submit_sms_pg_form) {
          if (!signUpSMS) {
            signUpEmailObj._SECONDARY_SUBMIT = 'sms';
            signUpEmailObj.SMS_PROMOTIONS = 0;
          }
          if (signUpSMS && (!me.userData || !me.userData.sms_optin)) {
            signUpEmailObj._SECONDARY_SUBMIT = 'sms';
            signUpEmailObj.MOBILE_PHONE = phone;
            signUpEmailObj.SMS_PROMOTIONS = 1;
          }
        }
      }

      if (oab_params) {
        signUpEmailObj.ACCEPTED_PRIVACY_POLICY = signUpPrivacy;
      }
      if (email_promotions) {
        signUpEmailObj.EMAIL_PROMOTIONS = signUpEmail;
        signUpEmailObj.DATA_PRIVACY_CONSENT = signUpEmail;
      }
      if (oab_params && !signUpPrivacy) {
        $this.removeClass('disabled');

        return;
      }

      signUpEmailParams.push(signUpEmailObj);

      generic.jsonrpc.fetch({
        method: 'rpc.form',
        params: JSON.stringify(signUpEmailParams),
        onSuccess: function (jsonRpcResponse) {
          if (loyaltyPromotion) {
            loyaltyJoin();
          } else {
            signUpEmailDone = true;
            doBooking();
          }
        },
        onFailure: function (jsonRpcResponse) {
          var errObjs = jsonRpcResponse.getMessages();

          errorContainer.css('display', 'block');
          errorMessages.css('display', 'none');

          // This error can be safely ignored. Perlgem throws the error because we are trying to "unsubscribe" a user that is already not subscribed.
          if (errObjs.length === 1 && errObjs[0].key === 'email_signup_not_subscribed') {
            doBooking();

            return;
          }

          for (var i = 0; i < errObjs.length; i += 1) {
            var myErr = errObjs[i];

            if (myErr && myErr.key) {
              if (
                myErr.key === 'required.pc_email_address.email_signup' ||
                myErr.key === 'invalid.pc_email_address.email_signup'
              ) {
                emailInput.addClass('error');
                errorMessages.filter('#error-signup-email').css('display', 'block');
              }

              if (myErr.key === 'required_dependency.sms_promotions.mobile_phone.dependency.sms') {
                phoneInput.addClass('error');
                errorMessages.filter('#error-signup-sms').css('display', 'block');
              }

              if (
                myErr.key ===
                'required_dependency.pc_email_address.email_promotions.dependency.email_signup'
              ) {
                signUpEmailInput.addClass('error');
                emailCheckboxLabel.addClass('error');
                errorMessages.filter('#error-signup-email-promotions').css('display', 'block');
              }

              if (myErr.key === 'invalid.mobile_phone.sms') {
                phoneInput.addClass('error');
                errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
              }
            }
          }

          emptyInputs();

          var phone_maxlength = phoneInput.attr('maxlength');
          var phone_regex = new RegExp(phoneInput.attr('pattern'));
          var phone_validation =
            oab_allow_mobile_pattern && appt_save_phone_code
              ? !phone_regex.test(phoneCodeInput.val() + phone)
              : phone.length > phone_maxlength || !phone_regex.test(phone);

          if (!phoneInput.val() && errorMessages.filter('#error-signup-sms').is(':hidden')) {
            errorMessages.filter('#error-book-phone').css('display', 'block');
            phoneInput.addClass('error');
          } else if (phone_validation) {
            var phone_format_length = phoneInput.attr('length');

            if (phone_format_length != phone.length) {
              errorMessages.filter('#error-book-phone-format').css('display', 'block');
              phoneInput.addClass('error');
            }
            phoneInput.addClass('error');
            errorContainer.css('display', 'block');
            errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
          }

          $this.removeClass('disabled');
        }
      });
    }
  };

  apptBook.AppointmentSelectSection.prototype.launchSelErrOverlay = function () {
    var me = this;

    this.jqBod.prepend(this.selErrOverlay);
    this.selErrOverlay.show();
    this.selErrOverlay.off('click');
    this.selErrOverlay.on('click', function (e) {
      e.preventDefault();
      var upObj = {
        sectionId: 'previous',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          updateMode: me.updateMode
        }
      };

      me.model.update(upObj);
      me.selErrOverlay.remove();
    });
  };

  apptBook.AppointmentSelectSection.prototype.launchBookConflictOverlay = function () {
    var me = this,
      selDate = this.calModel.getSelection().selectionDate;

    this.jqBod.prepend(this.bookConflictOverlay);
    this.calModel.update({ date: selDate });
    this.bookConflictOverlay.show();
    this.bookConflictOverlay.on('click', function (e) {
      e.preventDefault();
      me.bookConflictOverlay.off('click');
      me.bookConflictOverlay.remove();
    });
  };

  apptBook.AppointmentSelectSection.prototype.launchCounterMaxOverlay = function () {
    var me = this,
      selDate = this.calModel.getSelection().selectionDate;

    this.jqBod.prepend(this.bookCounterMax);
    this.calModel.update({ date: selDate });
    this.bookCounterMax.show();
    this.bookCounterMax.on('click', function (e) {
      e.preventDefault();
      me.bookCounterMax.off('click');
      me.bookCounterMax.remove();
    });
  };

  /* *
   *
   * Appointments Time Slot Selector Calendar and Mobile Calendar
   * This is a set of Classes that create objects that are the members of an MVC Calendar that displays and allows
   * selection of the available time slots of calendars coming from the API.
   *
   *
   *
   * */

  /**
   * CalendarModel
   * This is the model. It controls the calendars state and main logic.
   * It broadcasts updates to registered views and controllers
   *
   */

  apptBook.CalendarModel = function () {
    apptBook.CalendarModel.superclass.constructor.call(this);
    this.dataSet = false;
  };

  // CalendarModel is a Publisher in a Publisher Subscriber (event listening) pattern.
  ctrlopt.extend(apptBook.CalendarModel, ctrlopt.Publisher);

  apptBook.CalendarModel.prototype.setData = function (options) {
    if (this.dataSet) {
      return;
    }
    this.dataSet = true;
    this.calData = {};
    this.dataModel = options.dataModel;
    this.launchOverlay = options.launchOverlayCallback;
    this.counterId = options.counterId;
    this.calendarId = 0;
    this.apptDur = options.appointmentDuration;
    this.apptDurWithPadding = options.appointmentDurationWithPadding;
    this.serviceIds = options.serviceIds;
  };

  apptBook.CalendarModel.prototype.update = function (data) {
    if (!this.dataSet || !data) {
      return;
    }
    var me = this;

    this.calData.hilite = data.hilite ? true : false;
    this.calData.apptDur = this.apptDur;
    this.calData.apptDurWithPadding = this.apptDurWithPadding;
    this.calData.currentDate = new Date();
    this.calData.myDate = data.date || this.calData.myDate || this.calData.currentDate;
    this.calendarId = data.calendarId || this.calendarId;
    this.counterId = data.counterId || this.counterId;
    this.serviceIds = data.serviceIds || this.serviceIds;
    this.calData.apptTime = data.appointmentTime;

    this.dataModel.getCounter(
      this.counterId,
      { service_id: this.serviceIds },
      function (countData) {
        var cal,
          cals = countData.calendars;

        if (!cals || !cals.length) {
          me.calData.timeslots = null;
          if (me.launchOverlay && typeof me.launchOverlay === 'function') {
            me.launchOverlay();
          }
        } else {
          for (var i = 0, len = cals.length; i < len; i += 1) {
            cal = cals[i];
            if (parseInt(cal.id, 10) === parseInt(me.calendarId, 10)) {
              me.calData.timeslots = cal.timeslots;
              break;
            }
          }
        }

        me.fire('time_deselected');
        me.dispatchUpdate(me.calData);
      }
    );
  };

  apptBook.CalendarModel.prototype.dispatchUpdate = function (data) {
    this.fire('update', data);
  };

  apptBook.CalendarModel.prototype.getData = function () {
    return this.dataSet ? this.calData : null;
  };

  apptBook.CalendarModel.prototype.setSelection = function (selection) {
    this.selection = selection;
    this.selectionString =
      selection.getFullYear() +
      '-' +
      (selection.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      selection.getDate().toString().padStart(2, '0') +
      ' ' +
      selection.getHours().toString().padStart(2, '0') +
      ':' +
      ('0' + selection.getMinutes()).slice(-2) +
      ':00';
    this.fire('time_selected', this.selectionString);
  };

  apptBook.CalendarModel.prototype.getSelection = function () {
    return {
      selectionDate: this.selection,
      selectionString: this.selectionString
    };
  };

  /**
   * CalendarHeader is a class for concrete views of the CalendarModel.
   * It displays and manages the display logic for the Desktop Time Slot Calendar Header.
   *
   *
   * @param header JQuery required    a jquery object that contains a DOM element that represents the root element of the
   *                                  header.
   *
   *
   * @constructor
   */

  apptBook.CalendarHeader = function (header) {
    apptBook.CalendarHeader.superclass.constructor.call(this);
    this.initialized = false;
    this.header = header;
    this.rArrow = this.header.find('.next');
    this.lArrow = this.header.find('.previous');
    this.headContent = this.header.find('.cal-copy');
    this.headCopy = this.headContent.html();

    if (this.header.attr('data-months')) {
      this.months = this.header.attr('data-months').split(',');
    }

    var calTable = $('body').find('.weekdays');
    var cHCont = calTable.find('thead.col-heads');

    if (cHCont.attr('data-days')) {
      this.days = cHCont.attr('data-days').split(',');
    }
  };

  ctrlopt.extend(apptBook.CalendarHeader, ctrlopt.mvc.AbstractView);

  apptBook.CalendarHeader.prototype.defaultController = function () {
    return this.controller;
  };

  apptBook.CalendarHeader.prototype.onUpdate = function (data) {
    this.calData = data;
    var headOut,
      me = this,
      myDate = this.calData.myDate,
      dayOfWeek = startDayShift(myDate.getDay());

    (now = new Date()), (nowDay = startDayShift(now.getDay()));

    now.setDate(now.getDate() - nowDay);

    this.firstDay = new Date(myDate.getTime());
    this.firstDay.setDate(this.firstDay.getDate() - dayOfWeek);
    this.firstDay.setHours(0);

    this.lArrow.css('visibility', this.firstDay > now ? 'visible' : 'hidden');

    if (special_timeformat) {
      headOut =
        this.headCopy +
        ' ' +
        this.firstDay.getDate() +
        ' ' +
        this.months[this.firstDay.getMonth()] +
        ' ' +
        this.firstDay.getFullYear();
    } else if (oab_date_time_override) {
      var addDays = new Date(this.firstDay.getTime());

      addDays.setDate(addDays.getDate() + 6);
      addDays = new Date(addDays);
      headOut =
        this.firstDay.getFullYear() +
        this.header.attr('data-year-suffix') +
        ('0' + (this.firstDay.getMonth() + 1)).slice(-2) +
        this.header.attr('data-month-suffix') +
        this.firstDay.getDate() +
        this.header.attr('data-day-suffix') +
        '-' +
        ('0' + (addDays.getMonth() + 1)).slice(-2) +
        this.header.attr('data-month-suffix') +
        addDays.getDate() +
        this.header.attr('data-day-suffix');
    } else if (oab_hk_zh_dateformat_lang) {
      headOut =
        this.headCopy +
        ' ' +
        this.firstDay.getFullYear() +
        this.header.attr('data-year-suffix') +
        (this.firstDay.getMonth() + 1) +
        this.header.attr('data-month-suffix') +
        this.firstDay.getDate() +
        this.header.attr('data-day-suffix');
    } else if (oab_show_week_text_at_last) {
      headOut =
        this.firstDay.getDate() +
        ' ' +
        this.months[this.firstDay.getMonth()] +
        ' ' +
        this.firstDay.getFullYear() +
        ' ' +
        this.headCopy;
    } else if (oabDateFormat) {
      headOut =
        this.firstDay.getFullYear() +
        ' ' +
        this.header.attr('data-year-suffix') +
        ' ' +
        (this.firstDay.getMonth() + 1) +
        ' ' +
        this.header.attr('data-month-suffix') +
        ' ' +
        this.firstDay.getDate() +
        ' ' +
        this.header.attr('data-day-suffix') +
        ' ' +
        this.headCopy;
    } else if (appointment_booking_japan_date_format) {
      headOut =
        this.months[this.firstDay.getMonth()] +
        this.firstDay.getDate() +
        this.days[dayOfWeek] +
        ' ' +
        this.firstDay.getFullYear();
    } else {
      headOut =
        this.headCopy +
        ' ' +
        this.months[this.firstDay.getMonth()] +
        ' ' +
        this.firstDay.getDate() +
        ', ' +
        this.firstDay.getFullYear();
    }
    this.headContent.html(headOut);

    this.lArrow.off('click');
    this.rArrow.off('click');

    this.rArrow.css('cursor', 'pointer').on('click', function (e) {
      e.preventDefault();
      var nextDate = new Date(me.firstDay.getTime());

      nextDate.setDate(nextDate.getDate() + 7);

      me.rArrow.css('cursor', 'default').off('click');
      me.lArrow.css('cursor', 'default').off('click');
      me.model.update({ date: nextDate });
    });

    this.lArrow.css('cursor', 'pointer').on('click', function (e) {
      e.preventDefault();
      var prevDate = new Date(me.firstDay.getTime());

      prevDate.setDate(prevDate.getDate() - 7);

      me.rArrow.css('cursor', 'default').off('click');
      me.lArrow.css('cursor', 'default').off('click');
      me.model.update({ date: prevDate });
    });
  };

  /**
   * CalendarTimeSlots is a class for concrete views of the CalendarModel.
   * It displays and manages the display logic for the Desktop Calendar Time Slot Selector.
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalendarTimeSlots = function (options) {
    apptBook.CalendarTimeSlots.superclass.constructor.call(this);
    this.initialized = false;
    this.container = options.container;
    this.colHeads = options.colHeads;
    this.timeSlotRow = options.timeSlotRow;
    this.timeSlotsContainer = options.timeSlotsContainer;
    this.days = options.dayNames;
    this.months = options.monthNames;
    this.slotLabels = options.slotLabels;

    this.slots = [];
    var start_hour_time = this.container.attr('cal-start-hour') || 8;
    var end_hour_time = this.container.attr('cal-end-hour') || 23;
    var time_difference = end_hour_time - start_hour_time;

    for (var i = 0; i <= time_difference; i++) {
      if (time_interval) {
        for (var j = 0, k = 0; j < 60; k++) {
          this.slots.push({ hour: parseInt(start_hour_time) + i + ':' + k * time_interval });
          j = parseInt(j) + parseInt(time_interval);
        }
      } else {
        this.slots.push({ hour: parseInt(start_hour_time) + i });
      }
    }

    for (var i = 0, len = this.slots.length; i < len; i += 1) {
      if (this.slotLabels && this.slotLabels[i]) {
        this.slots[i].label = this.slotLabels[i];
      } else {
        this.slots[i].label = '&nbsp;';
      }
    }
  };

  ctrlopt.extend(apptBook.CalendarTimeSlots, ctrlopt.mvc.AbstractView);

  apptBook.CalendarTimeSlots.prototype.defaultController = function (data) {
    return null;
  };

  apptBook.CalendarTimeSlots.prototype.onUpdate = function (data) {
    this.calData = data;
    this.buildWeekView();
  };

  apptBook.CalendarTimeSlots.prototype.buildWeekView = function () {
    var hText,
      sText,
      hour,
      row,
      len = 7,
      myDate = this.calData.myDate,
      dayOfWeek = startDayShift(myDate.getDay());

    this.firstDay = new Date(myDate.getTime());
    this.firstDay.setDate(this.firstDay.getDate() - dayOfWeek);
    this.firstDay.setHours(0);
    this.lastDay = new Date(this.firstDay.getTime());
    this.lastDay.setDate(this.lastDay.getDate() + 6);
    this.lastDay.setHours(23, 59, 59, 999);

    for (var i = 0; i < len; i += 1) {
      var myDayDate = new Date(this.firstDay.getTime());

      myDayDate.setDate(myDayDate.getDate() + i);
      if (oabDateFormat) {
        hText = this.months[myDayDate.getMonth()] + '/' + myDayDate.getDate() + ' ' + this.days[i];
      } else if (oab_date_time_override) {
        hText = this.days[i] + ' ' + this.months[myDayDate.getMonth()] + '/' + myDayDate.getDate();
      } else if (appointment_booking_japan_date_format) {
        hText = this.months[myDayDate.getMonth()] + myDayDate.getDate() + this.days[i];
      } else {
        hText = this.days[i] + ' ' + myDayDate.getDate() + '/' + this.months[myDayDate.getMonth()];
      }
      this.colHeads.eq(i).removeClass('hilite').text(hText);
    }

    if (this.calData.hilite) {
      this.colHeads.eq(dayOfWeek).addClass('hilite');
    }

    this.timeSlotsContainer.empty();
    len = this.slots.length;
    i = 0;
    for (; i < len; i += 1) {
      sText = this.slots[i].label;
      hour = this.slots[i].hour;
      row = this.timeSlotRow.clone();
      row.find('td').attr('data-hour', hour).text(sText);
      this.timeSlotsContainer.append(row);
    }
    this.timeSlotsElems = this.timeSlotsContainer.find('td');
    this.setSlots();

    if (this.calData.apptTime) {
      this.setApptTime();
    }
  };

  apptBook.CalendarTimeSlots.prototype.processSlot = function (start, end) {
    var startIndex,
      myDay = new Date(start.getTime()),
      myDayOfWeek = startDayShift(start.getDay()),
      col = this.timeSlotsContainer.find('.day-' + myDayOfWeek),
      sHrDate = new Date(start.getTime()),
      len = this.slots.length,
      me = this,
      start_hr = start.getHours(),
      start_min = start.getMinutes(),
      startHour;

    if (time_interval) {
      if (time_interval < start_min) {
        start_min = Math.ceil(start_min / time_interval) * time_interval; // Round up to next time_interval
        if (start_min >= 60) {
          // If start_min exceeds the hour, then bump up to next hour
          start_min -= 60;
          start_hr += 1;
        }
        startHour = start_hr + ':' + start_min;
      } else if (start_min === 0) {
        startHour = start_hr + ':0';
      } else if (time_interval >= start_min) {
        if (time_interval == 60) {
          // Something like '9:60' is not a valid time, special case handling for time_interval of 60
          startHour = start_hr + ':0';
        } else {
          startHour = start_hr + ':' + time_interval;
        }
      }
    } else {
      startHour = start_min === 0 ? start_hr : start_hr + 1;
    }
    for (var i = 0; i < len; i += 1) {
      if (oab_start_time_display) {
        if (this.slots[i].hour === startHour || this.slots[i].hour >= startHour) {
          startIndex = i;
          break;
        }
      } else {
        if (this.slots[i].hour === startHour) {
          startIndex = i;
          break;
        }
      }
    }

    for (i = startIndex; i < len; i += 1) {
      var timeLeft,
        minLeft,
        sHr = this.slots[i].hour,
        set_Hr = time_interval ? sHr.split(':')[0] : sHr,
        set_Min = time_interval ? sHr.split(':')[1] : 0;

      sHrDate.setHours(set_Hr, set_Min, 0, 0);
      timeLeft = end.getTime() - sHrDate.getTime();
      minLeft = Math.floor(timeLeft / 60000);

      if (minLeft < this.calData.apptDurWithPadding) {
        break;
      } else {
        if (myDay <= sHrDate) {
          col
            .eq(i)
            .addClass('enabled')
            .on('click', function (e) {
              var slotDate = new Date(start.getTime()),
                $this = $(this);

              me.timeSlotsElems.removeClass('selected');
              $(this).addClass('selected');
              slotDate.setHours(parseInt($this.attr('data-hour'), 10));
              var minutes = parseInt($this.attr('data-hour').split(':')[1]) || 0;

              slotDate.setMinutes(minutes);
              me.model.setSelection(slotDate);
            });
        }
      }
    }
  };

  apptBook.CalendarTimeSlots.prototype.setSlots = function () {
    var timeslots = this.calData.timeslots;

    if (!timeslots) {
      return;
    }

    for (var i = 0, len = timeslots.length; i < len; i += 1) {
      var start = this.convertTimeString(timeslots[i].start_date),
        end = this.convertTimeString(timeslots[i].end_date),
        startTime = start.getTime();

      if (startTime >= this.firstDay.getTime() && startTime <= this.lastDay.getTime()) {
        this.processSlot(start, end);
      }
    }
  };

  apptBook.CalendarTimeSlots.prototype.setApptTime = function () {
    var me = this,
      apptDate = this.convertTimeString(this.calData.apptTime),
      apptTime = apptDate.getTime(),
      apptHour = time_interval
        ? (apptDate.getHours() + ':' + apptDate.getMinutes()).toString()
        : apptDate.getHours().toString();

    if (apptTime >= this.firstDay.getTime() && apptTime <= this.lastDay.getTime()) {
      this.timeSlotsContainer.find('.day-' + startDayShift(apptDate)).each(function () {
        var $this = $(this);

        if ($this.attr('data-hour') === apptHour) {
          $this.addClass('selected').addClass('enabled');
          me.model.setSelection(apptDate);
        }
      });
    }
  };

  apptBook.CalendarTimeSlots.prototype.convertTimeString = function (tString) {
    var split, dateArray, timeArray, y, m, d, hr, min, sec;

    split = tString.split(' ');
    dateArray = split[0].split('-');
    timeArray = split[1].split(':');

    y = parseInt(dateArray[0], 10);
    m = parseInt(dateArray[1], 10) - 1;
    d = parseInt(dateArray[2], 10);
    hr = parseInt(timeArray[0], 10);
    min = parseInt(timeArray[1], 10);
    sec = parseInt(timeArray[2], 10);

    return new Date(y, m, d, hr, min, sec);
  };

  /**
   * CalDatePicker is a class faor a concrete controller of the CalendarModel.
   * It manages the pickaday date picker and uses its input to update the Calendar Model
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalDatePicker = function (options) {
    apptBook.CalDatePicker.superclass.constructor.call(this);
    var offSet,
      me = this,
      $bod = options.jqBod,
      overlay = options.overlay,
      closeBtn = options.closeBtn,
      calContainer = options.calContainer,
      weekContainer = options.weekContainer,
      dpField = options.datepickerField,
      dpTrigger = options.datepickerTrigger,
      days = options.dayNames,
      months = options.monthNames,
      pikaday = new Pikaday({
        field: dpField[0],
        firstDay: parseInt(start_day),
        minDate: new Date(),
        maxDate: new Date(2020, 12, 31),
        yearRange: [2000, 2020],
        bound: false,
        container: calContainer[0],
        numberOfMonths: 2,
        onSelect: onDateSelect,
        i18n: {
          /* previousMonth : 'Previous Month',
          nextMonth     : 'Next Month',*/
          months: months,
          weekdays: days,
          weekdaysShort: days
        }
      });

    $bod.prepend(overlay);

    function openOverlay() {
      overlay.css('display', 'block');
      pikaday.gotoDate(new Date());
    }

    function closeOverlay() {
      overlay.css('display', 'none');
    }

    function onDateSelect(e) {
      var d = pikaday.getDate();

      if (me.model) {
        me.model.update({
          date: d,
          hilite: true
        });
      }
      closeOverlay();
    }

    dpTrigger.on('click', openOverlay);
    closeBtn.on('click', closeOverlay);
    // dpField.on('change', onDateSelect);
  };

  ctrlopt.extend(apptBook.CalDatePicker, ctrlopt.mvc.AbstractController);

  /* Mobile Appointment Select */

  /* Mobile Date Picker - Date Picker */

  /**
   * CalDatePickerMobile is a sub-class of CalDatePicker. It is a concrete controller of the CalendarModel.
   * It manages the pickaday date picker and uses its input to update the Calendar Model
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalDatePickerMobile = function (options) {
    apptBook.CalDatePickerMobile.superclass.constructor.call(this);
    var me = this,
      calContainer = options.calContainer,
      dpField = options.datepickerField,
      days = options.dayNames,
      months = options.monthNames,
      pikaday = new Pikaday({
        field: dpField[0],
        firstDay: parseInt(start_day),
        minDate: new Date(),
        maxDate: new Date(2020, 12, 31),
        yearRange: [2000, 2020],
        bound: false,
        container: calContainer[0],
        onSelect: onDateSelect,
        i18n: {
          /* previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',*/
          months: months,
          weekdays: days,
          weekdaysShort: days
        }
      });

    function onDateSelect(e) {
      var d = pikaday.getDate();

      if (me.model) {
        me.model.update({
          date: d,
          hilite: true
        });
      }
    }
  };

  ctrlopt.extend(apptBook.CalDatePickerMobile, ctrlopt.mvc.AbstractController);

  /* End Mobile Date Picker */

  /* Mobile Calendar Header */

  /**
   * CalendarHeaderMobile is a sub-class of CalendarHeader. It is a concrete view of the CalendarModel.
   * It displays and manages the display logic for the Desktop Time Slot Calendar Header.
   *
   *
   * @param header JQuery required    a jquery object that contains a DOM element that represents the root element of the
   *                                  header.
   *
   *
   * @constructor
   */

  apptBook.CalendarHeaderMobile = function (header) {
    apptBook.CalendarHeaderMobile.superclass.constructor.call(this);
    this.initialized = false;
    this.header = header;
    this.headCopy = this.header.html();
    this.months = this.header.attr('data-months').split(',');
    this.daySuffix = this.header.attr('data-day-suffix');
  };

  ctrlopt.extend(apptBook.CalendarHeaderMobile, ctrlopt.mvc.AbstractView);

  apptBook.CalendarHeaderMobile.prototype.onUpdate = function (data) {
    this.calData = data;
    var headOut,
      me = this,
      myDate = this.calData.myDate,
      dayOfWeek = startDayShift(myDate.getDay()),
      cHCont = $('body').find('.date-picker');

    this.days = cHCont.attr('data-days').split(',');

    if (appointment_booking_japan_date_format) {
      headOut =
        this.months[myDate.getMonth()] + myDate.getDate() + this.days[dayOfWeek] + this.daySuffix;
    } else {
      headOut =
        this.headCopy +
        ' ' +
        this.months[myDate.getMonth()] +
        ' ' +
        myDate.getDate() /* + ", " + myDate.getFullYear()*/;
    }

    this.header.html(headOut);
  };

  /* End Mobile Calendar Header */

  /* Mobile Time Slot Select */

  /**
   * CalendarTimeSlotsMobile is a sub-class of CalendarTimeSlots. It is a concrete view of the CalendarModel.
   * It displays and manages the display logic for the Mobile Time Slot Selector.
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalendarTimeSlotsMobile = function (options) {
    apptBook.CalendarTimeSlotsMobile.superclass.constructor.call(this, options);
  };

  ctrlopt.extend(apptBook.CalendarTimeSlotsMobile, apptBook.CalendarTimeSlots);

  apptBook.CalendarTimeSlotsMobile.prototype.onUpdate = function (data) {
    this.calData = data;
    if (!this.initialized) {
      this.buildWeekView();
      this.initialized = true;
    } else {
      this.tdElems.removeClass('selected');
      this.setSlots();
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.buildWeekView = function () {
    var hour, sText, row, rowCount, rows, rowIdx, tds, tdPerRow, tdElem, mod, cur, td;

    tds = this.timeSlotRow.find('td').remove();
    tdPerRow = tds.length;
    tdElem = tds.first();
    rowCount = Math.ceil(this.slots.length / tdPerRow);

    for (var i = 0; i < rowCount; i += 1) {
      row = this.timeSlotRow.clone();
      this.timeSlotsContainer.append(row);
    }

    rows = this.timeSlotsContainer.find('tr');
    i = 0;
    rowIdx = 0;
    for (var len = this.slots.length; i < len; i += 1) {
      sText = this.slots[i].label;
      hour = this.slots[i].hour;
      td = tdElem.clone();
      td.attr('data-hour', hour).text(sText);
      rows.eq(rowIdx).append(td);

      cur = i + 1;
      mod = cur % tdPerRow;

      if (mod === 0) {
        rowIdx += 1;
      }
    }
    this.tdElems = this.timeSlotsContainer.find('td');
    this.setSlots();

    if (this.calData.apptTime) {
      this.setApptTime();
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.processSlot = function (start, end) {
    var startIndex,
      myDay = new Date(start.getTime()),
      sHrDate = new Date(start.getTime()),
      len = this.slots.length,
      me = this,
      start_hr = start.getHours(),
      start_min = start.getMinutes(),
      startHour;

    if (time_interval) {
      if (time_interval < start_min) {
        start_min = Math.ceil(start_min / time_interval) * time_interval; // Round up to next time_interval
        if (start_min >= 60) {
          // If start_min exceeds the hour, then bump up to next hour
          start_min -= 60;
          start_hr += 1;
        }
        startHour = start_hr + ':' + start_min;
      } else if (start_min === 0) {
        startHour = start_hr + ':0';
      } else if (time_interval >= start_min) {
        if (time_interval == 60) {
          // Something like '9:60' is not a valid time, special case handling for time_interval of 60
          startHour = start_hr + ':0';
        } else {
          startHour = start_hr + ':' + time_interval;
        }
      }
    } else {
      startHour = start_min === 0 ? start_hr : start_hr + 1;
    }
    for (var i = 0; i < len; i += 1) {
      if (oab_start_time_display) {
        if (this.slots[i].hour === startHour || this.slots[i].hour >= startHour) {
          startIndex = i;
          break;
        }
      } else {
        if (this.slots[i].hour === startHour) {
          startIndex = i;
          break;
        }
      }
    }

    for (i = startIndex; i < len; i += 1) {
      var timeLeft,
        minLeft,
        sHr = this.slots[i].hour,
        set_Hr = time_interval ? sHr.split(':')[0] : sHr,
        set_Min = time_interval ? sHr.split(':')[1] : 0;

      sHrDate.setHours(set_Hr, set_Min, 0, 0);
      timeLeft = end.getTime() - sHrDate.getTime();
      minLeft = Math.floor(timeLeft / 60000);

      if (minLeft < this.calData.apptDurWithPadding) {
        break;
      } else {
        if (myDay <= sHrDate) {
          this.tdElems
            .eq(i)
            .addClass('enabled')
            .on('click', function (e) {
              var slotDate = new Date(start.getTime()),
                $this = $(this);

              me.tdElems.removeClass('selected');
              $(this).addClass('selected');
              slotDate.setHours(parseInt($this.attr('data-hour'), 10));
              var minutes = parseInt($this.attr('data-hour').split(':')[1]) || 0;

              slotDate.setMinutes(minutes);
              me.model.setSelection(slotDate);
            });
        }
      }
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.setSlots = function () {
    var timeslots = this.calData.timeslots,
      myDate = new Date(this.calData.myDate.getTime());

    myDate.setHours(0, 0, 0, 0);

    this.tdElems.removeClass('enabled').off('click');

    if (!timeslots) {
      return;
    }
    for (var i = 0, len = timeslots.length; i < len; i += 1) {
      var start = this.convertTimeString(timeslots[i].start_date),
        startDay = new Date(start.getTime());

      startDay.setHours(0, 0, 0, 0);

      if (startDay.getTime() === myDate.getTime()) {
        this.processSlot(start, this.convertTimeString(timeslots[i].end_date));
      }
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.setApptTime = function () {
    var me = this,
      apptDate = this.convertTimeString(this.calData.apptTime),
      apptTime = apptDate.getTime(),
      apptHour = time_interval
        ? (apptDate.getHours() + ':' + apptDate.getMinutes()).toString()
        : apptDate.getHours().toString();
  };

  /* End Mobile Time Slot Select */

  Drupal.behaviors.apptBookAppointments = {
    attach: function (context) {
      var self = this;
      var view = new apptBook.AppointmentSelectSection($('#appointments'));

      view.setModel(apptBook.sectionModel).startObserving();
      $('.artist-info', context).on('click', function () {
        $.colorbox.remove();
        var artist_node = $('#appointments', context).attr('data-artist-node');

        $.ajax({
          url: 'https://' + window.location.host + '/elc_api/' + artist_node + '/',
          type: 'GET',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Accept', 'HTML');
          },
          success: function (data) {
            var content =
              '<div class="app-artist-info">' + $('.content', data.rendered).html() + '</div>';
            var artistDescLimit = 200;
            var colorboxSettings = {
              html: content,
              close: '<i class="icon--remove"></i>',
              className: 'appt-artist-overlay',
              width: '70%',
              transition: 'none',
              opacity: '0.7',
              onComplete: function () {
                var cboxContent = $('#cboxContent');

                $('#cboxLoadedContent', cboxContent).css({
                  width: '100%',
                  height: '395px'
                });
                $('.app-artist-info', cboxContent).slick({
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  variableWidth: true,
                  infinite: false,
                  responsive: [
                    {
                      breakpoint: 640,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false,
                        centerMode: true
                      }
                    }
                  ]
                });
                $('.artist-description', cboxContent).each(function () {
                  var artistFullDesc = $(this).text();

                  if (artistFullDesc.length > artistDescLimit) {
                    var firstSet = artistFullDesc.substring(0, artistDescLimit);
                    var secondHalf = artistFullDesc.substring(
                      artistDescLimit,
                      artistFullDesc.length
                    );

                    $(this).empty().html(firstSet);
                    $(this).append('<a href="javascript:void(0);" class="read-more">...</a>');
                    $(this).append('<span class="more-text hidden">' + secondHalf + '</span>');
                  }
                });
                $('.read-more', cboxContent).on('click', function () {
                  $(this).parent().find('.more-text').removeClass('hidden');
                  $(this).parent().find('.read-more').addClass('hidden');
                });
                $('.slick-dots li button, .slick-prev, .slick-next', cboxContent).on(
                  'click',
                  function () {
                    $('.artist-description', cboxContent).each(function () {
                      $(this).find('.more-text').addClass('hidden');
                      $(this).find('.read-more').removeClass('hidden');
                    });
                  }
                );
                // override popup close button css for mobile screen only
                if ($(window).width() < 768) {
                  $('body', context).addClass('artistColorboxOverlay');
                  $('#cboxClose').css({
                    right: '11px',
                    top: '6px'
                  });
                  $(cboxContent).css('width', '97%');
                }
              }
            };
            var colorboxPcSettings = {
              width: '697px',
              height: '389px'
            };
            var colorboxMobileSettings = {
              width: '90%',
              height: '410px'
            };
            var overlay = $.extend(
              {},
              colorboxSettings,
              +site.client.isMobile ? colorboxMobileSettings : colorboxPcSettings
            );

            self.openWindow(overlay);
          }
        });
      });
    },
    openWindow: function (overlay) {
      $.colorbox(overlay);
    }
  };
})(jQuery);
